const IconBird = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 513 513" strokeWidth={1.5} stroke="currentColor" className="size-6">
<path fill="#000000" stroke="none"
      d="M513.000000,162.539368
	C509.693665,166.464966 505.724365,167.638367 500.901215,167.464783
	C493.948181,167.214523 486.999268,167.401321 480.015778,168.209427
	C467.264160,169.684967 455.636261,180.829895 454.334503,193.506836
	C452.237183,213.931458 453.161194,234.420059 453.520721,254.848206
	C454.070038,286.059998 445.124695,314.086365 427.474365,339.437164
	C407.740997,367.779816 381.402710,387.661072 348.761688,399.072113
	C332.021484,404.924408 314.822601,407.707489 297.025146,407.447174
	C274.709656,407.120728 252.384720,407.475128 230.066727,407.250885
	C225.852173,407.208557 223.917633,408.688354 222.345657,412.454712
	C212.448761,436.167023 202.309052,459.777954 192.271957,483.431824
	C189.368423,490.274414 187.017944,497.273254 182.201874,503.286987
	C178.669769,507.697449 173.813019,509.605042 169.236115,512.764038
	C162.645599,513.000000 156.291214,513.000000 149.257721,512.737549
	C147.726196,511.968964 146.916138,511.366089 146.015015,510.970947
	C128.329865,503.215668 111.635254,493.367615 93.970718,485.665344
	C73.477867,476.729858 69.003777,450.246246 82.674904,435.798248
	C85.040878,433.297821 87.360291,430.659088 89.643745,428.034210
	C100.635986,415.398285 111.505447,402.653778 122.615707,390.122711
	C136.814316,374.108307 151.410904,358.441406 165.373688,342.226654
	C169.286011,337.683319 174.119781,333.714874 176.953384,327.705048
	C163.101013,326.611969 149.884918,323.828857 137.047684,319.307709
	C111.503548,310.311188 90.332741,295.123474 73.022087,274.367279
	C64.691566,264.378693 58.170349,253.196091 51.309578,242.235199
	C38.376339,221.572800 25.643312,200.783997 12.570435,180.210800
	C8.870045,174.387390 5.901609,168.029205 1.000000,163.000000
	C1.000000,159.307098 1.000000,155.614182 1.308109,151.298752
	C3.722150,148.169968 6.114258,146.624969 9.677698,146.589539
	C38.790337,146.300140 67.900574,147.134735 97.022903,145.823624
	C114.971214,145.015579 132.644409,142.861435 150.189255,139.307556
	C156.880173,137.952225 156.803848,137.743759 155.039383,130.916794
	C149.543304,109.651894 146.111633,88.151779 146.578064,66.067970
	C146.947357,48.583473 146.821609,31.082394 146.552673,13.594264
	C146.471497,8.316389 147.745438,4.147911 152.000000,1.000000
	C155.361282,1.000000 158.722580,1.000000 162.661850,1.309741
	C164.799332,3.340570 166.595581,4.901947 167.881271,6.807757
	C179.176880,23.551605 192.502136,38.442535 207.817383,51.623009
	C221.762848,63.624615 236.976120,73.644653 253.968674,80.616409
	C274.098511,88.875343 295.417236,93.465233 316.240326,99.567993
	C327.442902,102.851204 338.081940,107.310997 345.704834,116.199982
	C350.835297,122.182503 351.992004,121.198616 356.703125,115.900703
	C365.406860,106.112877 373.638275,95.896294 382.521759,86.278915
	C401.113129,66.151756 433.545319,60.527840 458.234314,72.582451
	C473.768677,80.167244 483.692657,92.704643 491.091980,107.894875
	C498.148804,122.381920 504.953247,137.010742 513.000000,151.000000
	C513.000000,154.692902 513.000000,158.385818 513.000000,162.539368
M96.442719,456.506470
	C97.329521,461.085022 99.924294,464.074890 104.201515,466.125153
	C120.697868,474.032501 137.070984,482.196472 153.521866,490.199371
	C160.295013,493.494354 164.740677,491.672394 167.764160,484.594818
	C174.873337,467.953094 182.167007,451.387085 189.026581,434.643188
	C192.071884,427.209778 196.017899,420.095520 198.162521,411.850281
	C184.861908,416.374939 175.974655,425.142456 169.621902,436.774078
	C168.028427,439.691650 166.644257,442.687897 164.050827,444.967316
	C160.462936,448.120758 156.109314,448.227692 152.320328,446.713776
	C148.755127,445.289215 146.846848,441.807617 146.574387,437.485931
	C146.194916,431.467468 149.350708,426.969696 152.291840,422.395874
	C166.753494,399.906342 186.926819,387.186005 214.115402,386.647339
	C242.904953,386.076904 271.692200,387.232239 300.502258,385.871918
	C320.287750,384.937683 338.952423,380.606445 356.572540,372.034119
	C372.954681,364.064056 387.327057,353.272552 399.459900,339.437897
	C411.811066,325.354370 420.967255,309.637695 426.627045,291.806335
	C431.561188,276.261139 432.389252,260.205688 432.608459,244.103943
	C432.828491,227.942032 433.121735,211.758530 432.551056,195.613892
	C431.765991,173.405350 449.881531,152.093033 471.253235,147.427216
	C475.559662,146.487045 480.127106,147.746841 484.726776,145.610245
	C479.289062,134.710129 473.843414,124.243553 468.818054,113.578896
	C464.773468,104.995636 458.776398,98.351486 450.632111,93.682594
	C433.605011,83.921478 411.925049,87.100189 398.283386,101.939804
	C392.230927,108.523750 386.802307,115.677483 380.841156,122.349777
	C368.567017,136.088104 355.935242,149.511429 343.850494,163.412003
	C339.322021,168.620926 334.027557,173.293427 330.642517,179.553329
	C331.908295,181.260605 333.659637,182.161072 335.370453,183.168747
	C338.082214,184.765961 340.885376,186.290161 343.324036,188.250565
	C347.513672,191.618576 348.681000,197.261719 346.491028,201.741608
	C344.313812,206.195419 339.663788,208.463257 334.286011,207.163040
	C331.757294,206.551666 329.323883,205.237442 327.060303,203.885132
	C300.560059,188.053436 274.487122,171.483536 247.423309,156.627441
	C232.576965,148.477859 216.291138,146.427124 199.608490,149.155624
	C183.733780,151.751999 168.792908,158.117950 152.953430,161.046722
	C133.351166,164.671265 113.750343,167.722015 93.716728,167.430130
	C75.055992,167.158218 56.388287,167.339493 37.723820,167.387344
	C35.825802,167.392212 33.741776,166.738129 31.846870,168.367767
	C32.337376,169.429871 32.716072,170.519012 33.303986,171.480194
	C37.894764,178.985580 43.012978,186.215958 47.023010,194.017166
	C52.230267,204.147476 59.933212,210.003143 70.657532,214.124817
	C94.833412,223.416382 118.944969,231.220383 145.413239,228.807007
	C156.872787,227.762131 168.054398,225.908615 179.035156,222.634247
	C190.104553,219.333450 200.167969,213.838287 210.277420,208.393036
	C216.688980,204.939590 223.350937,206.429077 226.173065,211.395493
	C229.259460,216.826965 227.380814,223.216431 221.225159,227.303268
	C217.498215,229.777618 213.645920,232.115555 209.657837,234.135483
	C187.382690,245.417740 163.517242,250.656021 138.749863,251.199295
	C122.661613,251.552185 106.649208,249.640823 91.160980,244.728210
	C86.654526,243.298843 82.141556,241.889969 77.673782,240.484985
	C77.469650,240.980637 77.323502,241.158676 77.364128,241.266083
	C77.594032,241.874023 77.815826,242.495117 78.135735,243.057465
	C90.036446,263.976532 106.964935,279.823273 127.866173,291.386658
	C148.251190,302.664459 170.588272,306.354645 193.557571,306.529999
	C201.136169,306.587830 208.735306,305.442780 216.306732,304.668518
	C237.631378,302.487762 256.576996,294.379669 273.956573,281.974579
	C279.947296,277.698578 284.794586,272.156952 290.819305,268.039764
	C295.152557,265.078491 302.216827,266.219513 305.343689,269.935425
	C308.383545,273.547974 308.429962,281.547211 304.843140,284.602142
	C300.540527,288.266663 296.762817,292.459015 292.273315,295.951874
	C268.162811,314.709900 241.038834,325.448212 210.497025,327.335327
	C208.510834,327.458069 207.284027,328.197418 205.944839,329.747345
	C199.330627,337.402435 192.471100,344.845032 185.735397,352.395874
	C177.454453,361.678955 169.161453,370.952087 160.963837,380.308533
	C152.232071,390.274628 143.685974,400.404022 134.910736,410.331268
	C126.017044,420.392517 116.679367,430.073425 108.061501,440.361023
	C103.959091,445.258240 98.529877,449.296570 96.442719,456.506470
M185.424759,129.564423
	C195.919312,126.426086 206.699051,126.472824 217.499329,126.639595
	C233.796188,126.891235 248.837830,131.640335 262.817413,139.705460
	C277.750977,148.320938 292.491608,157.273270 307.235657,166.211792
	C309.120911,167.354706 310.327026,167.706467 311.910370,165.934219
	C318.987305,158.013016 326.125763,150.146622 333.266479,142.282669
	C335.273895,140.071899 335.188904,137.915298 333.295349,135.733475
	C329.692078,131.581558 325.959808,127.630867 320.979218,124.995071
	C312.659058,120.591919 303.424957,119.068695 294.573212,116.366898
	C272.585815,109.655762 250.022522,104.783997 229.597000,93.435692
	C212.803436,84.105293 197.327438,73.163681 183.637131,59.724350
	C178.406143,54.589260 173.466278,49.157619 168.393738,43.861118
	C167.507980,73.847527 168.793442,102.861931 178.096939,130.687454
	C178.548889,130.908279 178.719269,131.070480 178.844955,131.041138
	C180.772598,130.591202 182.694427,130.116257 185.424759,129.564423
z"/>
        <path fill="#000000" stroke="none"
              d="
M324.891541,364.269409
	C315.131348,367.028625 305.570282,367.705811 295.894196,367.350983
	C290.699188,367.160492 287.123749,364.145630 286.685425,359.488281
	C285.996002,352.162628 288.397400,348.275665 293.879761,346.605927
	C299.397583,344.925415 305.070496,345.824127 310.665924,344.859009
	C326.973206,342.046234 341.296570,335.481873 353.977661,324.867371
	C372.171509,309.638397 382.162811,290.058075 385.490936,266.855347
	C386.099731,262.611237 385.504456,258.252441 386.617157,253.990295
	C388.054596,248.484207 392.091309,246.045761 399.391052,246.680115
	C403.970520,247.078079 407.208435,250.790161 407.343475,255.812698
	C408.095459,283.773590 399.055695,308.108643 380.851349,329.337494
	C365.885040,346.790375 347.314484,358.155426 324.891541,364.269409
z"/>
        <path fill="#000000" stroke="none"
              d="M262.795197,366.295166
	C259.103546,368.000275 255.527969,367.850159 252.287643,366.822144
	C247.419205,365.277557 245.167862,358.891113 246.836014,352.918274
	C248.118958,348.324646 253.299255,345.855164 259.890289,346.695190
	C264.283203,347.255035 267.140625,351.078186 267.389130,356.198547
	C267.586548,360.266754 266.788361,363.725708 262.795197,366.295166
z"/>
        <path fill="#000000" stroke="none"
              d="M435.210236,109.209534
	C441.762970,104.896011 448.751648,105.816536 452.124512,111.105385
	C455.065277,115.716682 453.489105,123.133530 448.944519,126.069351
	C445.297363,128.425430 437.966034,127.682121 435.074860,124.663116
	C431.776794,121.219215 431.705353,114.415390 435.210236,109.209534
z"/>
</svg>
);

export default IconBird;
